import React, { useContext } from "react";
import { useLazyLoadQuery, graphql } from "react-relay";
import { GreenMachineContext } from "../../GreenMachineContext";

const GET_SESSIONS = graphql`
  query SelectSessionListQuery($slateID: ID!) {
    greenMachineSessionsForSlate(slateId: $slateID) {
      id
      numLineups
      minSalary
      maxSalary
      playersPerLineup
      reportedBy {
        username
      }
      errorReport
      errorMessage

      greenmachinelineupsetSet {
        edges {
          node {
            id
          }
        }
      }
      slate {
        gameType {
          gametypelineupsetSet {
            edges {
              node {
                lineupSet {
                  lineuprosterslotSet {
                    edges {
                      node {
                        order
                        amount
                        rosterSlot {
                          name
                        }
                        selectable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default function SelectSessionList() {
  const {
    selectedSlateID,
    initializeGreenMachineSession,
    updateCurrentStage,
  } = useContext(GreenMachineContext);

  const data = useLazyLoadQuery(GET_SESSIONS, { slateID: selectedSlateID });

  return (
    <div>
      {data.greenMachineSessionsForSlate.map((greenMachineSession) => {
        return (
          <p key={greenMachineSession.id} className="gm-session-option">
            <button
              onClick={(e) => {
                e.preventDefault();
                initializeGreenMachineSession(greenMachineSession);
                updateCurrentStage();
              }}
            >
              {greenMachineSession.errorReport
                ? greenMachineSession.reportedBy.username +
                  " (" +
                  greenMachineSession.errorMessage +
                  ")"
                : "Mine"}
            </button>
          </p>
        );
      })}
    </div>
  );
}
